import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import { encodeHtml } from 'devextreme/core/utils/string';
import { custom } from 'devextreme/ui/dialog';

import moment from 'moment';

import { AuthService } from 'src/app/shared/services';
import { ufaService } from '../ufe.service';
import { PrintService } from 'src/app/pdf-ovi/pdfUFA.service';
import { DxDateBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-ufe',
  templateUrl: './ufe.component.html',
  styleUrls: ['./ufe.component.scss'],
  providers: [ufaService]
})
export class UfeComponent implements OnInit {
  @ViewChild('dateBox1', { static: false }) dateBox1!: DxDateBoxComponent;
  @ViewChild('dateBox2', { static: false }) dateBox2!: DxDateBoxComponent;

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  
  datumSlanje1: any;
  datumSlanje2: any;
  ulaznefakture: any = [];
  vrstaUFA: any;
  statusUFA: any;
  omoguciEditiranje = false;
  tablica: any;
  tablicaPDV: any;
  stavkeISPIS: any;
  rekapitulacija: any;
  popisPrimkiPDF: any = [];
  dokument: any;
  stavkeUFE: any = [];
  napomena: any;
  stavke: any = [];
  kalkulacija: any;
  zaglavljeUFE: any;
  aktivnoBtn = false;
  zavisniPDF: any;
  dodaniTroskovi: any = [];
  iznosFakture: any;
  watermark: any;
  osnovica: any;
  porezUFA: any;

  datumUfa: any;

  poruka: string;

  statusArray: any = [
    {idstatus: 1, status_vrijednost: 'I', status_naziv: 'U IZRADI'},
    {idstatus: 2, status_vrijednost: 'Z', status_naziv: 'ZAVRŠENO'},
    {idstatus: 3, status_vrijednost: 'S', status_naziv: 'STORNIRANO'},
    {idstatus: 4, status_vrijednost: 'K', status_naziv: 'KNJIŽENO'}
  ];

  knjizenoArray: any = [
    {idknjizeno: 1, knjizeno_vrijednost: 1, knjizeno_naziv: 'DA'},
    {idknjizeno: 2, knjizeno_vrijednost: 0, knjizeno_naziv: 'NE'}
  ];

  prikazi: any = [
    {idprikaz: 1, pr_naziv: 'DA'},
    {idprikaz: 0, pr_naziv: 'NE'}
  ];

  constructor(
    private api: ufaService,
    private printService: PrintService,
    private router: Router,
    private authService: AuthService
  ) {
    this.statusUFA = sessionStorage.getItem('statusUFA');
    let datumiStorage = (sessionStorage.getItem('datumiUFA') || '')
    var podatak = null ;
      try {
        podatak = JSON.parse(datumiStorage)
      } catch (d) {}
      if(podatak != null){
        this.datumSlanje1 = podatak['datum1'];
        this.datumSlanje2 = podatak['datum2'];
      } else {
        this.datumSlanje1 = new Date();
        this.datumSlanje1.setDate(1)
        this.datumSlanje2 = new Date();
      }
      if(this.statusUFA === 'n'){   
        this.nezavrseno();
      } else {
        this.zavrseno();
      }
   }

  ngOnInit(): void {
    // this.podaciOFirmi();
    setTimeout(() => {
      this.dateBox1.instance.focus();
    }, 100)
  }

  focusNext(fieldRef: string) {
    const fieldMap: { [key: string]: any } = {
      'dateBox1': this.dateBox2
    };

    const nextField = fieldMap[fieldRef];
    if (nextField) {
      setTimeout(() => {
        if (nextField.instance) {
          nextField.instance.focus();
        } else {
          // For buttons or other elements
          nextField.nativeElement?.focus();
        }
      }, 50);
    }
  }

  onCellPreparedUfa(e){
    if (e.rowType === "data"){
      if(e.data.uf_status === 'S'){
        e.cellElement.style.color = 'red';
      }
    }
  }

  ponistiFilter(){
    sessionStorage.removeItem('datumiUFA')
    this.datumSlanje1 = new Date();
    let datum =  this.datumSlanje1.setDate(1)
    this.datumSlanje1 = moment(datum).format('YYYY-MM-DD');
    this.datumSlanje2 = moment(new Date()).format('YYYY-MM-DD');

    if(this.statusUFA === 'n'){
      this.dohvatiNezavrseneUFE(this.datumSlanje1, this.datumSlanje2);
    } else {
      this.dohvatiZavrseneUFE(this.datumSlanje1, this.datumSlanje2);
    }
  }

  editDatum1(e){
    if(e.value !== null){
      this.datumSlanje1 = moment(e.value).format('YYYY-MM-DD');
      if(this.datumSlanje2){
        let datumi = {
          datum1: this.datumSlanje1,
          datum2: this.datumSlanje2
        }
        sessionStorage.setItem('datumiUFA', JSON.stringify(datumi));
        if(this.statusUFA === 'n'){
          this.dohvatiNezavrseneUFE(this.datumSlanje1, this.datumSlanje2);
        } else {
          this.dohvatiZavrseneUFE(this.datumSlanje1, this.datumSlanje2);
        }
      }
    }
  }

  editDatum2(e){
    if(e.value !== null){
        this.datumSlanje2 = moment(e.value).format('YYYY-MM-DD');
        if(this.datumSlanje1){
          let datumi = {
            datum1: this.datumSlanje1,
            datum2: this.datumSlanje2
          }
          sessionStorage.setItem('datumiUFA', JSON.stringify(datumi));
          if(this.statusUFA === 'n'){
            this.dohvatiNezavrseneUFE(this.datumSlanje1, this.datumSlanje2);
          } else {
            this.dohvatiZavrseneUFE(this.datumSlanje1, this.datumSlanje2);
          }
        } else {
          notify('Potrebno je odrediti oba datuma!' , 'info');
        }
    }
  }

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'naslovTablice'
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'plus',
          onClick: this.novaUFA.bind(this)
        }
      },
      {
        locateInMenu:'auto',
        location: 'before',
        widget: 'dxButton',
        template: "zavrseno"
      },
      {
        locateInMenu:'auto',
        location: 'before',
        widget: 'dxButton',
        template: "nezavrseno"
      }
    )
  }

  //// na + na tipkovnici otvara se popup za dodavanje
  /*
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if(event.code === 'NumpadAdd' && event.key === '+'){
      this.router.navigate(['ufa/' + 0]);
    }
  }
  */
 
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.ctrlKey && (event.code === 'Equal' || event.code === 'NumpadAdd')) {
      event.preventDefault();
      this.router.navigate(['ufa/' + 0]);
    }
  }

  zavrseno(){
    this.vrstaUFA = 'Završene';
    this.statusUFA = 'z';
    this.dohvatiZavrseneUFE(this.datumSlanje1, this.datumSlanje2)   
    this.omoguciEditiranje = false;
    this.aktivnoBtn = true;    
  }

  nezavrseno(){
    this.vrstaUFA = 'Nezavršene';
    this.statusUFA = 'n';
    this.dohvatiNezavrseneUFE(this.datumSlanje1, this.datumSlanje2);
    this.omoguciEditiranje = true;
    this.aktivnoBtn = false;    
  }

  konvertiraj(a){
    return this.authService.konvertirajCijenu().konvertiraj(a);
  }
  konvertiraj2(a){
    var a = a;
    var predznak = '';
    if (typeof (a) == "number") {
      if (isNaN(a) || a === Infinity) {
        var str = '';
      } else {
        var str = String(a);
      }
    } else if (typeof (a) == "string") {
      var str = a;
    } else {
      var str = '';
    }

    if (str.indexOf("-") == 0) {
      str = str.substring(1, str.length);
      predznak = '-';
    }

    var duzina = str.length;
    var tocka = str.indexOf(".");
    var zarez = str.indexOf(",");
    if (tocka > 0) {
      var decimalnomjesto = tocka;
    } else if (zarez > 0) {
      var decimalnomjesto = zarez;
    } else {
      var decimalnomjesto = -1;
    }
    
    if (typeof (str) == "string") {
      if (decimalnomjesto > 0) {

        if (decimalnomjesto > 3) {
          var brojevi = '';
          var broj = 0;
          for (var i = 3; i < decimalnomjesto; i = i + 3) {
            brojevi = '.' + str.substring(decimalnomjesto - i, decimalnomjesto - (i - 3)) + brojevi;
            broj = i;
          }
          var prvi = str.substring(0, decimalnomjesto - broj) + brojevi;

        } else {
          var prvi = str.substring(0, decimalnomjesto);
        }
        if (decimalnomjesto == duzina - 3) {
          var decimal = str.substring(decimalnomjesto + 1, duzina) + '0';
        } else {
          //ako se zeli da pokazuje sve znamenke ili da zaokruzi na dvije
          //var decimal = str.substring(decimalnomjesto+1, duzina);
          var decimal = str.substring(decimalnomjesto + 1, duzina);
        }
        var ukupno = prvi + ',' + decimal;
        return predznak + ukupno;
      } else {
        if (duzina > 3) {
          var brojevi = '';
          var broj = 0;
          for (var i = 3; i < duzina; i = i + 3) {
            brojevi = '.' + str.substring(duzina - i, duzina - (i - 3)) + brojevi;
            broj = i;
          }
          var prvi = str.substring(0, duzina - broj) + brojevi;
          var decimal = '00';
          var ukupno = prvi + ',' + decimal;
          return predznak + ukupno;
        } else {
          var decimal = '00';
          if (str == '') {
            str = '0';
          }
          var ukupno = str + ',' + decimal;
          return predznak + ukupno;
        }
      }
    }
    return false;
  }
  dohvatiZavrseneUFE(datum1, datum2){
    this.ulaznefakture = [];
    this.poruka = 'Učitavanje...';
    let podaci = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      datumod: datum1,
      datumdo: datum2,
      zavrsena: 1
    }
    this.api.ufaPopis(podaci).subscribe(res => {
      if (res.success == true) {
        this.ulaznefakture = res.data;
      } else{
        this.poruka = 'Nema podataka za prikaz!';
      } 
    });
  }

  dohvatiNezavrseneUFE(datum1, datum2){
    this.ulaznefakture = [];
    this.poruka = 'Učitavanje...';
    let podaci = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      datumod: datum1,
      datumdo: datum2,
      zavrsena: 0
    }
    this.api.ufaPopis(podaci).subscribe(res => {
      if (res.success == true) {
        this.ulaznefakture = res.data;
      } else{
        this.poruka = 'Nema podataka za prikaz!';
      }  
    });
  }

  calculateBrojUFE(data){
    return [data.uf_broj, data.pg_godina].join("/");
  }

  novaUFA(){
    this.router.navigate(['ufa/' + 0]);
  }

  uredi(e: any){
    sessionStorage.setItem('statusUFA', 'n');
    this.router.navigate(['ufa/' + e.data.uf_id + '/' + 'n']);
  }

  prikazUFA(e){
    this.router.navigate(['ufa/' + e.data.uf_id + '/' + 'z']);
    sessionStorage.setItem('statusUFA', 'z');
  }

  obrisi(e: any){
    let podaci = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      idufa: e.data.uf_id
    }
    let result = confirm("<i>Jeste li sigurni da želite obrisati odabranu UFU?</i>", "Brisanje");
    result.then((dialogResult) => {
      if(dialogResult === true){
        this.api.ufaObrisi(podaci).subscribe(res => {
          if(res.success === true){
            notify('Uspješno ste obrisali UFU!', 'success');
          } else {
            notify(res.message, 'error');
          }      
          this.dohvatiNezavrseneUFE(this.datumSlanje1, this.datumSlanje2);          
        })
      } 
    });
  }

  storniraj(data){
    let result = confirm("<i>Jeste li sigurni da želite stornirati ovaj račun?</i>", "STORNIRANJE UFE");
      result.then((dialogResult) => {
        if(dialogResult === true){        
          this.potpitanje(data.data.uf_id);        
        } 
    });
  }

  potpitanje(ufa){
    let encodedMessage = encodeHtml('Želite li istovremeno stornirati i primke unutar ulazne fakture?');
    let myDialog = custom({
        title: 'Storniranje primki',
        messageHtml: encodedMessage,
        buttons: [{
            text: 'SAMO UFA',
            onClick: (e) => {
                return { buttonText: e.component.option("text") }
            }
        },{
          text: 'UFA I PRIMKE',
          onClick: (e) => {
              return { buttonText: e.component.option("text") }
          }
        },
        {
        text: 'ODUSTANI',
        onClick: (e) => {
            return { buttonText: e.component.option("text") }
        }
    }]
    });
    myDialog.show().then((dialogResult) => {    
        if(dialogResult.buttonText === 'SAMO UFA'){
          this.storniranjeUFE(ufa, '0');
        } else if(dialogResult.buttonText === 'UFA I PRIMKE'){
          this.storniranjeUFE(ufa, '1');
        } 
      })
    }

    storniranjeUFE(ufa, primka){
      let podaci = {
        access_token: this.access_token,
        idkorisnik: this.idkorisnik,
        idfirma: this.idfirma,
        idufa: ufa,
        storno_primki: primka
      }
      this.api.storno_kalkulacija(podaci).subscribe(res => {
      if(res.data[0][0].rezultat == 1){
          notify(res.data[0][0].poruka, 'success');
        } else {
          notify(res.data[0][0].poruka, 'error');
        }
        this.dohvatiZavrseneUFE(this.datumSlanje1, this.datumSlanje2);
      })
    }
  

  // podaciOFirmi(){
  //   let podaci = {
  //     idkorisnik: this.idkorisnik,
  //     idfirma: this.idfirma,
  //     access_token: this.access_token, 
  //     imeModula: 'skladisno_poslovanje',
  //   }
  //   this.api.firmaInfo(podaci).subscribe(res =>{
  //     if(res.success === true){
  //       this.zaglavljeUFE = res.data[0];
  //     }
  //   })
  // }

  ispisUFE(data) {
    this.printService.pdfUFA(data);
  }
}